// extracted by mini-css-extract-plugin
export default {"newProject_container":"NovaRegra_newProject_container__CTOHz"};